import React, { useState, useContext } from 'react'
import { Body1, SubBody2 } from '@flatsy/core/MaterialUi/Typo'
import { Drawer } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import WarningIcon from '@flatsy/core/Icon/Warning'
import theme from '@flatsy/core/MuiTheme/theme'
import { FileContext } from 'src/containers/Application/Files/Context'
import {
  requiredUploadToFlatArray,
  restrictedWithUploadedFiles,
} from '@flatsy/utils/Functions/Files/RequiredUpload'
import { KindTranslate, FilesKind } from '@flatsy/types/Files'
import clsx from 'clsx'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { ButtonSecondaryOutlined } from '@flatsy/core/MaterialUi/Button'
import useStyles from './Style'
import { UploadedItemType } from '../Type'

const UploadedItemMobile: React.FC<UploadedItemType> = ({ file }) => {
  const classes = useStyles()
  const { Uppy } = useContext(FileContext)
  const [kind, setKind] = useState<string>(file.kind || '')
  const [openDrawer, setOpenDrawer] = useState(false)
  const {
    applicants: { current },
    files: { filesByApplicant },
  } = useContext(FileContext)
  const UppyFiles = Uppy?.formatedFiles

  const renderSingleButton = (kind: FilesKind) => {
    const onKindClick = () => {
      Uppy?.updateFormatedFiles(file.id, kind)
      setKind(kind)
      setOpenDrawer(false)
    }
    return (
      <ButtonSecondaryOutlined className={classes.choice} onClick={onKindClick}>
        {KindTranslate[kind]}
      </ButtonSecondaryOutlined>
    )
  }

  const createList = () => {
    const required = restrictedWithUploadedFiles(
      requiredUploadToFlatArray(current?.required_uploads),
      filesByApplicant,
      {
        UppyFiles,
        currentFile: file,
      }
    )
    return required.filesKinds.map((doc) => {
      return renderSingleButton(doc)
    })
  }

  const onClickOpenDrawer = () => {
    setOpenDrawer(true)
  }
  const onClickCloseDrawer = () => {
    setOpenDrawer(false)
  }

  return (
    <>
      <button type="button" className={classes.container} onClick={onClickOpenDrawer}>
        {kind && kind !== '' ? (
          <div className={clsx(classes.iconContainer, classes.doneContainer)}>
            <DoneIcon className={classes.done} />
          </div>
        ) : (
          <div className={clsx(classes.iconContainer, classes.warningContainer)}>
            <WarningIcon className={classes.warning} color={theme.palette.warning.main} />
          </div>
        )}
        <div className={classes.detail}>
          <Body1>{kind ? KindTranslate[kind as FilesKind] : 'Nature de la pièce inconnue'}</Body1>
          <SubBody2 className={classes.detailName}>{file.name}</SubBody2>
        </div>
        <ChevronRightIcon className={classes.buttonIcon} />
      </button>
      <Drawer
        anchor="bottom"
        open={openDrawer}
        onClose={onClickCloseDrawer}
        className={classes.drawer}
      >
        <Body1>Quelle est la nature de cette pièce ? </Body1>
        <div className={classes.choiceContainer}>{createList()}</div>
      </Drawer>
    </>
  )
}

export default UploadedItemMobile
